import qcCityInfoStore from "../store/qcCityInfo";

const useQcCityInfos = (playerId) => {
    const cityInfos = qcCityInfoStore((state) => state.cityInfos);
    const setCityInfoPoint = qcCityInfoStore((state) => state.setCityInfoPoint);
    const setCityInfoBlood = qcCityInfoStore((state) => state.setCityInfoBlood);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        playerCityInfo: playerId == null ? {} : cityInfos[playerId] ?? {},
        cityInfos,
        setCityInfoPoint,
        setCityInfoBlood
    };
};

export default useQcCityInfos;
